module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/54c9026ca39fa16e462d9753dfbe4aad.png";